export const RANKING_AUCTION_CREATE_PAGE_PATH = '/auction/ranking/create'

export const RANKING_AUCTION_LIST_PAGE_PATH = '/auction/ranking/list'
